<button mat-icon-button [matMenuTriggerFor]="userMenu" class="main-button">
  <img src="{{ avatarUrl() }}" alt="User" />
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
  <div class="usermenu-header">
    <div class="avatar-container" matTooltip="Change Avatar">
      <a href="{{ changeAvatarUrl() }}">
        <img src="{{ avatarUrl() }}" alt="User Profile" />
      </a>
    </div>
    <div class="usermenu-data">
      {{ this.currentUser?.username }}
      <br />
      <span id="user-displayrole" class="mat-caption">
        {{ currentRole?.name }}
        <ng-container *ngIf="currentRole?.name === 'Center' && currentUser?.centerName"> ({{ currentUser?.centerName }}) </ng-container>
      </span>
    </div>
  </div>

  <div *ngIf="canSwitchRoles" (click)="$event.stopPropagation()">
    <mat-form-field appearance="fill">
      <mat-label>Switch Role</mat-label>
      <mat-select [(ngModel)]="switchRoleSelection" name="switchRoleSelection">
        <mat-option *ngFor="let role of availableRoles" [value]="role">
          {{ role.name }}<span *ngIf="role.name === 'Center' && switchCenterSelection"> ({{ switchCenterSelection }})</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="switchRoleSelection?.name === 'Center'" appearance="fill">
      <mat-label>Select Center</mat-label>
      <mat-select [(ngModel)]="switchCenterSelection" name="switchCenterSelection">
        <mat-option *ngFor="let center of availableCenters" [value]="center[0]"> {{ center[1].name }} ({{ center[0] }}) </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      class="bigButton"
      [disabled]="switchRoleSelection?.name === 'Center' && !switchCenterSelection"
      (click)="switchRole(switchRoleSelection, switchCenterSelection)"
    >
      Switch Role
    </button>
  </div>

  <div *ngIf="hasSwitchedRole()" class="clear-spoof-container">
    <button mat-menu-item (click)="clearSwitchedRole()">
      <mat-icon>clear</mat-icon>
      Clear Role Switch
    </button>
  </div>

  <button id="logout" mat-menu-item (click)="authService.logout()">
    <mat-icon>exit_to_app</mat-icon>
    Logout
  </button>
</mat-menu>
